class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.inputClear = this.querySelector('#clear-search');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.popularSearches = this.querySelector('#popular-searches');
    this.popularSearchesItems = this.querySelectorAll('.PopularSearches__Content .PopularSearches__Item');
    this.searchResultsTab = this.querySelector('.Search__Results-Tab');
    this.searchInputSuggestionText = this.querySelector('#predictive-search-suggestion-input');

    this.inputClear.addEventListener('click', () => {
      this.input.value = '';
      this.inputClear.classList.add('hidden');
      this.searchInputSuggestionText.textContent = '';
      this.input.focus();
      this.onChange();
    });

    this.popularSearchesItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.input.value = item.textContent.trim();
        this.onChange();
      });
    });

    this.input.addEventListener('keydown', (ev) => {
      this.searchInputSuggestionText.textContent = '';
      this.searchInputSuggestionText.classList.add('hidden');

      if (ev.key === 'Enter' && this.querySelector('#predictive-search-suggestion').textContent.length) {
        this.input.value = this.querySelector('#predictive-search-suggestion').textContent;
        this.onChange();
      }
    });

    this.input.addEventListener('input', () => {
      this.adjustSuggestionPosition.call(this);
    });

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    if (this.input.value.length) {
      this.input.addEventListener(
        'focus',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  adjustSuggestionPosition() {
    const tempElement = document.createElement('span');
    tempElement.style.fontSize = '18px';
    tempElement.style.visibility = 'hidden';
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.textContent = this.input.value;
    document.body.appendChild(tempElement);

    const inputWidth = tempElement.offsetWidth;
    this.searchInputSuggestionText.style.left = `${inputWidth + 50}px`;
    document.body.removeChild(tempElement);
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      this.inputClear.classList.add('hidden');
      this.popularSearches.classList.remove('hidden');
      this.searchResultsTab.classList.add('hidden');
      return;
    } else {
      this.inputClear.classList.remove('hidden');
      this.popularSearches.classList.add('hidden');
      this.searchResultsTab.classList.remove('hidden');
    }

    this.querySelectorAll('.Search__Results-Tab button').forEach((otherButton) => {
      otherButton.classList.remove('active');
    });
    this.querySelectorAll('.Search__Results-Tab button')[0].classList.add('active');

    const objectTypeInput = this.querySelector('input[name="type"]');
    const activeObjectType = this.querySelectorAll('.Search__Results-Tab button')[0]?.dataset.objectType;
    if (objectTypeInput && activeObjectType) objectTypeInput.value = activeObjectType;

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=query,product,collection,page,article`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        const bestsellersSlider = this.querySelector('.bestsellers-slider');
        if (bestsellersSlider) {
          $(bestsellersSlider).not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false,
                },
              },
            ],
          });
        }

        const suggestionText = this.querySelector('#predictive-search-suggestion').textContent;
        let commonPrefix = '';
        for (let i = 0; i < searchTerm.length && i < suggestionText.length; i++) {
          if (searchTerm[i] === suggestionText[i]) {
            commonPrefix += searchTerm[i];
          } else {
            break;
          }
        }

        // Replace the common prefix with spaces
        let modifiedSuggestionText = suggestionText.replace(new RegExp(`^${commonPrefix}`, 'g'), commonPrefix.replace(/./g, ' '));
        this.searchInputSuggestionText.textContent = modifiedSuggestionText;

        if (searchTerm.length) {
          this.searchInputSuggestionText.classList.remove('hidden');
        }

        this.querySelectorAll('#predictive-search-results-queries-list li').forEach((suggestion) => {
          suggestion.addEventListener('click', () => {
            this.input.value = suggestion.textContent.trim();
            this.onChange();
          });
        });

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
